export default "__VITE_ASSET__c4a5400e__"